import React from 'react';

import { Typography } from '@mui/material';
import { SquareCheck } from 'lucide-react';
import { TaskTitleField } from 'src/components/workflow/workflow-detail/side-panel/TaskTitleField';
import { makeStyles } from 'tss-react/mui';

import { TaskPageCard } from './TaskPageCard';

const useStyles = makeStyles()(theme => ({
  icon: {
    alignItems: 'center',
    backgroundColor: theme.appColors.selectedBackgroundNav,
    borderRadius: 12,
    color: theme.palette.primary.main,
    display: 'flex',
    flexShrink: 0,
    height: 56,
    justifyContent: 'center',
    width: 56,
  },
  row: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(2),
  },
  subtitle: {
    color: theme.appColors.iconsType,
    fontSize: 14,
    lineHeight: '20px',
  },
  text: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: theme.spacing(0.25),
    minWidth: 0,
  },
}));

interface TaskPageHeaderProps {
  isReadOnly: boolean;
  subtitle: string;
  taskId: string;
  title: string;
  editDisabledReason?: string | null;
}

/** The task page's title card: what the task is and where it sits. */
export function TaskPageHeader({
  editDisabledReason,
  isReadOnly,
  subtitle,
  taskId,
  title,
}: TaskPageHeaderProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <TaskPageCard>
      <div className={classes.row}>
        <div className={classes.icon}>
          <SquareCheck size={24} />
        </div>
        <div className={classes.text}>
          <TaskTitleField
            editDisabledReason={editDisabledReason}
            isReadOnly={isReadOnly}
            taskId={taskId}
            title={title}
            variant="page"
          />
          {Boolean(subtitle) && <Typography className={classes.subtitle}>{subtitle}</Typography>}
        </div>
      </div>
    </TaskPageCard>
  );
}
